export default function getAppName() {
  var _window$hubspot$bende, _window;
  // @ts-expect-error - No bender type in the hubspot window object yet
  return (_window$hubspot$bende = (_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 || (_window = _window.bender) === null || _window === void 0 ? void 0 : _window.currentProject) !== null && _window$hubspot$bende !== void 0 ? _window$hubspot$bende : undefined;
}